import { fork } from 'redux-saga/effects';
import { commentSaga } from './sagas/comments.saga';
import { resultsSaga } from './sagas/results.saga';
import { personaSaga } from './sagas/persona.saga';
import { mapSaga } from './sagas/map.saga';
import { dashboardSaga } from './sagas/dashboard.saga';
import { summarySaga } from './sagas/summary.saga';

export function* resultsMainSaga() {
	yield fork(dashboardSaga);
	yield fork(summarySaga);
	yield fork(commentSaga);
	yield fork(resultsSaga);
	yield fork(personaSaga);
	yield fork(mapSaga);
}
